// extracted by mini-css-extract-plugin
module.exports = {"whoWeAre_content_wrapper":"AboutUs_whoWeAre_content_wrapper__2N-4R","aboutContentWrap":"AboutUs_aboutContentWrap__1HVGH"};